/**
 * USE:
 * @click="func(arg)"
 * =>
 * @click="event => focusController.wrapper(event, () => func(arg))"
 */

const focusClass = "focused"

export default {
  focusClass,

  removeAllFocuses() {
    document.body
      .querySelectorAll(`.${this.focusClass}`)
      .forEach((elem) => elem.classList.remove(this.focusClass))
  },

  wrapper({ target }, callback, parentTagName = "tr") {
    this.removeAllFocuses()

    target.closest(parentTagName).classList.add(this.focusClass)

    callback()
  }
}
